export enum BudgetType {
    SAVINGS = "Saving for a goal",
    PAY_DEBT = "Paying off debt",
    CONTROL_SPENDING = "Controlling spending",
    EMERGENCY_FUND = "Building Emergency Fund"
}